<template>
  <v-card class="promo-wrap mx-auto pa-0 pa-sm-3 mt-sm-5" width="470">
    <v-card-text>
      <div style="display: inline;">
        <img style="width: 60px;float:right" :src="walletBg" alt="" />
        <div class="promo-title mb-2">{{ $t('promoMaxRegModal.title') }}</div>
      </div>
      <div>
        <p class="font-weight-regular regist-txt" style="text-align: left;padding-top: 10px;max-width: 320px; line-height: 17px;">
          {{ $t('promoMaxRegModal.desc') }}
        </p>
        <p class="font-weight-bold mb-1 mt-4" style="font-size: 13px">{{ $t('promoMaxRegModal.explain') }}</p>
      </div>
      <div class="mxw-wallet-benefit">
        <table>
          <tr>
            <td class="d-block mr-2"><img :src="tick" alt="" /></td>
            <td>{{ $t('promoMaxRegModal.benefit1') }}</td>
          </tr>
          <tr>
            <td class="d-block mr-2"><img :src="tick" alt="" /></td>
            <td>{{ $t('promoMaxRegModal.benefit2') }}</td>
          </tr>
          <tr>
            <td class="d-block mr-2"><img :src="tick" alt="" /></td>
            <td>{{ $t('promoMaxRegModal.benefit3') }}</td>
          </tr>
        </table>

        <span style="font: Italic 12px/16px Open Sans;color: #555555;">{{ $t('promoMaxRegModal.benefit6') }}</span>
      </div>
      <div class="btn-box d-flex mb-2">
        <v-btn
          @click="continueMaxWalletModal"
          class="btn-common mb-2 mr-2"
          height="50"
          x-large
          :large="$vuetify.breakpoint.xsOnly"
        >
          {{ $t('promoMaxRegModal.continueWithMaxWallet') }}
        </v-btn>
        <v-btn
          @click="showDownloadModal"
          class="btn-common-outline mb-2"
          height="50"
          x-large
          :large="$vuetify.breakpoint.xsOnly"
        >
          {{ $t('promoMaxRegModal.downloadNow') }}
        </v-btn>
      </div>
      <div class="register-page">
        <div class="d-flex align-center" style="font-size: 14px;">
          <a href="javascript:void(0)" @click="showRegisterForm">
            <v-icon style="font-size: 14px;" color="#1976d2">mdi-arrow-left</v-icon> {{ $t('promoMaxRegModal.registerPage') }}</a
          >
        </div>
      </div>
      <transition name="fade" mode="out-in" enter-active-class="slideInDown" leave-active-class="fadeOutBottom">
        <div v-show="downloadModalShow" class="download-modal" style="">
          <!-- <div class="text-weight-light" style="font-size:14px;">{{$t('max.register.question')}}<a href="#">{{$t('max.register.helpCenter')}}</a></div> -->
          <div class="btns-group" style="margin-top:15px;">
            <a v-for="(value, name, index) in btnList" :href="value.path" target="_blank" :key="index">
              <img :src="value.icon" alt />
            </a>
          </div>
          <div>
            <div style="font-size: 14px">{{ $t('promoMaxRegModal.unableDownload') }}</div>
            <div v-html="$t('promoMaxRegModal.downloadLink').replace('{ios}', grxIpa).replace('{android}', grxApk)"></div>
          </div>
        </div>
      </transition>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'PromoMaxRegModal',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    pkgType: {
      type: String,
      required: true
    },
    large: {
      type: Boolean,
      default: false
    },
    medium: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      walletBg: require('@/assets/images/home/max-wallet.png'),
      tick: require('@/assets/images/tick.svg'),
      downloadModalShow: false,
      btnList: {
        max_ios_store: { icon: require('@/assets/images/home/grx_ios_store.svg'), path: '' },
        max_android_store: { icon: require('@/assets/images/home/grx_android_store.svg'), path: '' }
      },
      grxIpa: '',
      grxApk: '',
      layout: 1
    };
  },
  methods: {
    showDownloadModal() {
      this.downloadModalShow = true;
      this.layout = 2;
    },
    showRegisterForm() {
      this.$emit('update:show', false);
      this.$emit('showRegisterForm');
    },
    continueMaxWalletModal() {
      this.$emit('showMaxRegister');
    },
    assignEnvConfig() {
      this.btnList['max_ios_store'].path = 'https://apps.apple.com/app/id1456349663';
      this.btnList['max_android_store'].path = 'https://play.google.com/store/apps/details?id=com.maxonrow.wallet';
      this.grxIpa = window.env.maxWalletApp.ipa;
      this.grxApk = window.env.maxWalletApp.apk;
    }
  },
  created() {
    this.assignEnvConfig();
  }
};
</script>

<style lang="stylus" scoped>
@import "../../regist.scoped.styl";
@import "../../../common.styl";
.promo-wrap {
  .v-card__text {
    color: #0c0c0c;

    .promo-title {
      font-size: 2.1rem;
    }

    .mxw-wallet-benefit {
      background: #F5F5F8 0% 0% no-repeat padding-box;
      padding: 10px;
      margin-bottom: 15px;
    }

    .btn-box {
      .v-btn::v-deep {
        flex: 1;
        padding: 0 10px;
        white-space: normal;

        .v-btn__content {
          flex: 1;
        }
      }
    }

    .register-page {
      margin-top: 0px;
    }

    .mxw-wallet-benefit td {
      font-size: 14px;
    }

    .download-model {
      background: red;
      padding: 20px;
    }

    .bottom-section {
      background-color: #F5F5F8;
      margin: 10px -15px -15px -15px;
      min-height: 150px;
      border-bottom-left-radius: 6px;
      border-bottom-right-radius: 6px;
      padding: 20px;

      .img-step {
        max-width: 100px;
        width: 100%;
      }
    }
    table {
      border-collapse: separate;
      border-spacing: 0 0.5em;
    }
  }
}

@media only screen and (max-width: 599px) {
  .promo-wrap {
    .v-card__text {
      .promo-title {
        font-size: 1.6rem;
      }
    }
  }
}
</style>
